import ppt from '../ui/assets/img/files/ppt.svg';
import doc from '../ui/assets/img/files/doc.svg';
import pdf from '../ui/assets/img/files/pdf.svg';
import csv from '../ui/assets/img/files/csv.svg';
import txt from '../ui/assets/img/files/txt.png';
import fallback from '../ui/assets/img/files/fallback.svg';

export const getFileExtension = (filename = '') => filename.split('.').pop();

export const getIconByExtension = (ext = '') => {
  let file;
  switch (ext?.toLowerCase()) {
    case 'pdf':
      file = pdf;
      break;

    case 'doc':
    case 'docx':
    case 'odt':
      file = doc;
      break;

    case 'csv':
    case 'xls':
    case 'xlsx':
    case 'ods':
      file = csv;
      break;

    case 'ppt':
    case 'pptx':
    case 'pps':
    case 'ppsx':
    case 'odp':
      file = ppt;
      break;

    case 'txt':
    case 'rtf':
      file = txt;
      break;

    default:
      file = fallback;
      break;
  }

  return file;
};

//? MIME types instead of extension are needed to make DnD work
export const acceptedDocsTypes = [
  //pdf
  'application/pdf',
  //txt, rtf/doc, docx, odt
  'text/plain',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.oasis.opendocument.text',
  //csv, xls, xlsx, ods
  'text/csv',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.oasis.opendocument.spreadsheet',
  //ppt/pps, pptx, ppsx, odp
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  'application/vnd.oasis.opendocument.presentation',
];
